<template>
    <v-navigation-drawer
        app
        right
        v-model="value"
        :value="value"
        @input="$emit('input', $event)"
        v-bind="$attrs"
        :mobile-break-point="$vuetify.breakpoint.thresholds.sm"
        width="280"
        class="pa-2 elevation-1"
        :mini-variant="mini"
        :mini-variant-width="70"
    >
        <v-list dense nav :shaped="!mini">
            <v-list-item link color="primary" :to="{ path: '/' }">
                <v-list-item-icon>
                    <v-icon>mdi-view-dashboard</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('dashboard') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link color="primary" :to="{ name: 'FaxesList' }">
                <v-list-item-icon>
                    <v-icon>mdi-inbox-arrow-up</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('sent_faxes_list') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link color="primary" :to="{ name: 'Inbox' }">
                <v-list-item-icon>
                    <v-icon>mdi-inbox-arrow-down</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('fax_inbox') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link color="primary" :to="{ name: 'SubscriptionClassesList' }">
                <v-list-item-icon>
                    <v-icon>mdi-package-variant-closed</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('subscription_classes') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link color="primary" :to="{ name: 'SubscriptionList' }">
                <v-list-item-icon>
                    <v-icon>mdi-package-variant</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('subscriptions') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link color="primary" :to="{ name: 'UsersList' }" v-if="true || userCan('users')">
                <v-list-item-icon>
                    <v-icon>mdi-account-multiple</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('users') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link color="primary" :to="{ name: 'FaxChannels' }">
                <v-list-item-icon>
                    <v-icon>mdi-asterisk</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('fax_channels') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link color="primary" :to="{ name: 'FaxNumbers' }">
                <v-list-item-icon>
                    <v-icon>mdi-pound</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('fax_numbers') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link color="primary" :to="{ name: 'BlacklistNumbers' }">
                <v-list-item-icon>
                    <v-icon>mdi-database-remove</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('blacklist_numbers') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link color="primary" :to="{ name: 'Connectors' }"  v-if="userCan('connectors')">
                <v-list-item-icon>
                    <v-icon>mdi-account-network</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('connectors') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link color="primary" :to="{ name: 'Resellers' }"  v-if="userCan('resellers')">
                <v-list-item-icon>
                    <v-icon>mdi-account-network</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('resellers') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link color="primary" :to="{ name: 'Receipts' }"  v-if="userCan('receipts')">
                <v-list-item-icon>
                    <v-icon>mdi-account-cash</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('receipts') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
          <v-list-item link color="primary" :to="{ name: 'Commissions' }" v-if="userCan('receipts')">
            <v-list-item-icon>
              <v-icon>mdi-cash</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="text-capitalize">{{ $t('commissions') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
            <v-list-item link color="primary" :to="{ name: 'Tickets', query : { orders : [{ column_name : 'assigned_user_id', value : 'desc'},{ column_name : 'created_at', value : 'desc'}], filters : [{ operand : 'IsEqualToOrNull', value : user.user_id, column_name : 'assigned_user_id'},{ operand : 'IsEqualTo', value : 'pending', column_name : 'status'}]} }">
                <v-list-item-icon>
                    <v-icon>mdi-face-agent</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('tickets') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link color="primary" :to="{ name: 'SettlementRequests' }">
                <v-list-item-icon>
                    <v-icon>mdi-math-log</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('SettlementRequests') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link color="primary" :to="{ name: 'Logs' }">
                <v-list-item-icon>
                    <v-icon>mdi-math-log</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="text-capitalize">{{ $t('logs') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <template v-slot:append>
            <div class="pa-2">
                <v-btn block outlined color="error" @click="signOut">
                    <v-icon :left="!mini" dark>mdi-power</v-icon>
                    <template v-if="!mini">
                        {{$t('sign_out')}}
                    </template>
                </v-btn>
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
    import AccountService from '@/services/AccountService'
    import { mapGetters } from 'vuex';

    export default {
        props: {
            value: Boolean,
            mini: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters({
                user: 'auth/user'
            })
        },
        watch: {
            value(newVal) {
                this.$emit('input', newVal);
            }
        },
        methods: {
            signOut() {
                AccountService.signOut();
                this.$router.push({ name : "SignIn"})
            }
        }
    }
</script>